import React  from 'react';
import './CategoryList.css'

function CategoryList () {
    
        return (
            <div>
                    <div className=" categoryPageWrapper">
  <div className="categoryPageContainer">
    
    {/* <!-- Header --> */}
    <div className="categoryPageHeader">
      <div className="categoryPageHeaderLeft">
        <h2 className="categoryPageTitle">Danh mục dùng chung</h2>

        <div className="category-page-bread-crumb">
          <span className="category-page-bread-crumb-item">Trang chủ</span>
          <span className="categoryPageBreadcrumbSlash">/</span>

          <span className="category-page-bread-crumb-item">
            Quản trị hệ thống
          </span>
          <span className="categoryPageBreadcrumbSlash">/</span>

          <span className="category-page-bread-crumb-item">
            Danh mục dùng chung
          </span>
          <span className="categoryPageBreadcrumbSlash">/</span>

          <span className="category-pgebreadcrumb-active">
            Danh sách danh mục
          </span>
        </div>
      </div>

      <div className="categoryPageHeaderRight">
        <button className="categoryPageAddButton">
          <span className="categoryPageAddIcon">+</span>
          Thêm danh mục
        </button>
      </div>
    </div>

    {/* <!-- Search --> */}

    <div className="categorySearchContainer">
      <div className="row">

        <div className="col-sm-3">
          <div className="categorySearchGroup">
            <label className="category-search-label">
              Tên danh mục
            </label>

            <div className="categorySearchInputWrapper">
              <input
                type="text"
                className="category-search-input"
                value="Nhập tên danh mục..."
              />

              <span className="category-search-input-icon">
                🔍
              </span>
            </div>
          </div>
        </div>

        <div className="col-sm-3">
          <div className="categorySearchGroup">
            <label className="category-search-label">
              Loại danh mục
            </label>

            <select className="category-search-select-share">
              <option>-- Tất cả --</option>
            </select>
          </div>
        </div>

        <div className="col-sm-3">
          <div className="categorySearchGroup">
            <label className="category-search-label">
              Trạng thái
            </label>

            <select className="category-search-select-share">
              <option>-- Tất cả --</option>
            </select>
          </div>
        </div>

        <div className="col-sm-3">
          <div className="categorySearchButtonGroup">

            <button className="category-reset-button-refresh">
              ↻ Đặt lại
            </button>

            <button className="category-search-button-btn">
              🔍 Tìm kiếm
            </button>

          </div>
        </div>

      </div>
    </div>

    {/* <!-- Table --> */}
    <div className="category-table-container-list">

      <div className="categoryTableHeader">
        <h3 className="categoryTableTitle">
          Danh sách danh mục
        </h3>

        <button className="categoryRefreshButton">
          ↻
        </button>
      </div>

      <table className="category-table-data-show">
        <thead className="categoryTableHead">
          <tr className="categoryTableHeadRow">
            <th className="categoryTableHeadCell">STT</th>
            <th className="categoryTableHeadCell">Tên danh mục</th>
            <th className="categoryTableHeadCell">Mã danh mục</th>
            <th className="categoryTableHeadCell">Loại danh mục</th>
            <th className="categoryTableHeadCell">Mô tả</th>
            <th className="categoryTableHeadCell">Trạng thái</th>
            <th className="categoryTableHeadCell">Sắp xếp</th>
            <th className="categoryTableHeadCell">Ngày cập nhật</th>
            <th className="categoryTableHeadCell">Thao tác</th>
          </tr>
        </thead>

        <tbody className="categoryTableBody">

          <tr className="categoryTableBodyRow">
            <td className="categoryTableBodyCell">1</td>
            <td className="categoryTableBodyCell categoryNameText">
              Đơn vị hành chính
            </td>
            <td className="categoryTableBodyCell">DONVI_HC</td>
            <td className="categoryTableBodyCell">
              Danh mục hệ thống
            </td>
            <td className="categoryTableBodyCell">
              Danh sách đơn vị hành chính
            </td>
            <td className="categoryTableBodyCell">
              <span className="categoryStatusActive">
                Hoạt động
              </span>
            </td>
            <td className="categoryTableBodyCell">1</td>
            <td className="categoryTableBodyCell">
              20/05/2024 10:30
            </td>
            <td className="categoryTableBodyCell">
              <div className="categoryActionGroup">
                <button className="categoryEditButton">
                    <i className="fa-solid fa-pen"></i>
                </button>
                <button className="categoryCopyButton">
                    <i className="fa-regular fa-copy"></i>
                </button>
                <button className="categoryDeleteButton">
                    <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>

          <tr className="categoryTableBodyRow">
            <td className="categoryTableBodyCell">2</td>
            <td className="categoryTableBodyCell categoryNameText">
              Lĩnh vực hoạt động
            </td>
            <td className="categoryTableBodyCell">LINHVUC_HD</td>
            <td className="categoryTableBodyCell">
              Danh mục nghiệp vụ
            </td>
            <td className="categoryTableBodyCell">
              Lĩnh vực hoạt động của doanh nghiệp
            </td>
            <td className="categoryTableBodyCell">
              <span className="categoryStatusActive">
                Hoạt động
              </span>
            </td>
            <td className="categoryTableBodyCell">2</td>
            <td className="categoryTableBodyCell">
              20/05/2024 10:30
            </td>
            <td className="categoryTableBodyCell">
              <div className="categoryActionGroup">
                <button className="categoryEditButton">
                    <i className="fa-solid fa-pen"></i>
                </button>
                <button className="categoryCopyButton">
                    <i className="fa-regular fa-copy"></i>
                </button>
                <button className="categoryDeleteButton">
                    <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>

          <tr className="categoryTableBodyRow">
            <td className="categoryTableBodyCell">3</td>
            <td className="categoryTableBodyCell categoryNameText">
              Loại hình doanh nghiệp
            </td>
            <td className="categoryTableBodyCell">LOAIHINH_DN</td>
            <td className="categoryTableBodyCell">
              Danh mục nghiệp vụ
            </td>
            <td className="categoryTableBodyCell">
              Phân loại loại hình doanh nghiệp
            </td>
            <td className="categoryTableBodyCell">
              <span className="categoryStatusActive">
                Hoạt động
              </span>
            </td>
            <td className="categoryTableBodyCell">3</td>
            <td className="categoryTableBodyCell">
              20/05/2024 10:30
            </td>
            <td className="categoryTableBodyCell">
              <div className="categoryActionGroup">
                 <button className="categoryEditButton">
                    <i className="fa-solid fa-pen"></i>
                </button>
                <button className="categoryCopyButton">
                    <i className="fa-regular fa-copy"></i>
                </button>
                <button className="categoryDeleteButton">
                    <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>

          <tr className="categoryTableBodyRow">
            <td className="categoryTableBodyCell">4</td>
            <td className="categoryTableBodyCell categoryNameText">
              Quy mô doanh nghiệp
            </td>
            <td className="categoryTableBodyCell">QUYMO_DN</td>
            <td className="categoryTableBodyCell">
              Danh mục nghiệp vụ
            </td>
            <td className="categoryTableBodyCell">
              Phân loại quy mô doanh nghiệp
            </td>
            <td className="categoryTableBodyCell">
              <span className="categoryStatusActive">
                Hoạt động
              </span>
            </td>
            <td className="categoryTableBodyCell">4</td>
            <td className="categoryTableBodyCell">
              20/05/2024 10:30
            </td>
            <td className="categoryTableBodyCell">
              <div className="categoryActionGroup">
                 <button className="categoryEditButton">
                    <i className="fa-solid fa-pen"></i>
                </button>
                <button className="categoryCopyButton">
                    <i className="fa-regular fa-copy"></i>
                </button>
                <button className="categoryDeleteButton">
                    <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>

          <tr className="categoryTableBodyRow">
            <td className="categoryTableBodyCell">5</td>
            <td className="categoryTableBodyCell categoryNameText">
              Ngành nghề kinh doanh
            </td>
            <td className="categoryTableBodyCell">NGANHNGHE_KD</td>
            <td className="categoryTableBodyCell">
              Danh mục nghiệp vụ
            </td>
            <td className="categoryTableBodyCell">
              Danh sách ngành nghề kinh doanh
            </td>
            <td className="categoryTableBodyCell">
              <span className="categoryStatusActive">
                Hoạt động
              </span>
            </td>
            <td className="categoryTableBodyCell">5</td>
            <td className="categoryTableBodyCell">
              20/05/2024 10:30
            </td>
            <td className="categoryTableBodyCell">
              <div className="categoryActionGroup">
                 <button className="categoryEditButton">
                    <i className="fa-solid fa-pen"></i>
                </button>
                <button className="categoryCopyButton">
                    <i className="fa-regular fa-copy"></i>
                </button>
                <button className="categoryDeleteButton">
                    <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>

          <tr className="categoryTableBodyRow">
            <td className="categoryTableBodyCell">6</td>
            <td className="categoryTableBodyCell categoryNameText">
              Trạng thái hồ sơ
            </td>
            <td className="categoryTableBodyCell">TRANGTHAI_HS</td>
            <td className="categoryTableBodyCell">
              Danh mục nghiệp vụ
            </td>
            <td className="categoryTableBodyCell">
              Trạng thái xử lý hồ sơ
            </td>
            <td className="categoryTableBodyCell">
              <span className="categoryStatusActive">
                Hoạt động
              </span>
            </td>
            <td className="categoryTableBodyCell">6</td>
            <td className="categoryTableBodyCell">
              20/05/2024 10:30
            </td>
            <td className="categoryTableBodyCell">
              <div className="categoryActionGroup">
                <button className="categoryEditButton">
                    <i className="fa-solid fa-pen"></i>
                </button>
                <button className="categoryCopyButton">
                    <i className="fa-regular fa-copy"></i>
                </button>
                <button className="categoryDeleteButton">
                    <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>

          <tr className="categoryTableBodyRow">
            <td className="categoryTableBodyCell">7</td>
            <td className="categoryTableBodyCell categoryNameText">
              Hình thức xử lý
            </td>
            <td className="categoryTableBodyCell">HINHTHUC_XL</td>
            <td className="categoryTableBodyCell">
              Danh mục nghiệp vụ
            </td>
            <td className="categoryTableBodyCell">
              Hình thức xử lý hồ sơ
            </td>
            <td className="categoryTableBodyCell">
              <span className="categoryStatusActive">
                Hoạt động
              </span>
            </td>
            <td className="categoryTableBodyCell">7</td>
            <td className="categoryTableBodyCell">
              20/05/2024 10:30
            </td>
            <td className="categoryTableBodyCell">
              <div className="categoryActionGroup">
                 <button className="categoryEditButton">
                    <i className="fa-solid fa-pen"></i>
                </button>
                <button className="categoryCopyButton">
                    <i className="fa-regular fa-copy"></i>
                </button>
                <button className="categoryDeleteButton">
                    <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>

          <tr className="categoryTableBodyRow">
            <td className="categoryTableBodyCell">8</td>
            <td className="categoryTableBodyCell categoryNameText">
              Nguồn gốc xuất xứ
            </td>
            <td className="categoryTableBodyCell">NGUONGOC_XX</td>
            <td className="categoryTableBodyCell">
              Danh mục nghiệp vụ
            </td>
            <td className="categoryTableBodyCell">
              Nguồn gốc xuất xứ hàng hóa
            </td>
            <td className="categoryTableBodyCell">
              <span className="categoryStatusActive">
                Hoạt động
              </span>
            </td>
            <td className="categoryTableBodyCell">8</td>
            <td className="categoryTableBodyCell">
              20/05/2024 10:30
            </td>
            <td className="categoryTableBodyCell">
              <div className="categoryActionGroup">
                 <button className="categoryEditButton">
                    <i className="fa-solid fa-pen"></i>
                </button>
                <button className="categoryCopyButton">
                    <i className="fa-regular fa-copy"></i>
                </button>
                <button className="categoryDeleteButton">
                    <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>

          <tr className="categoryTableBodyRow">
            <td className="categoryTableBodyCell">9</td>
            <td className="categoryTableBodyCell categoryNameText">
              Đơn vị tính
            </td>
            <td className="categoryTableBodyCell">DONVITINH</td>
            <td className="categoryTableBodyCell">
              Danh mục hệ thống
            </td>
            <td className="categoryTableBodyCell">
              Danh sách đơn vị tính
            </td>
            <td className="categoryTableBodyCell">
              <span className="categoryStatusActive">
                Hoạt động
              </span>
            </td>
            <td className="categoryTableBodyCell">9</td>
            <td className="categoryTableBodyCell">
              20/05/2024 10:30
            </td>
            <td className="categoryTableBodyCell">
              <div className="categoryActionGroup">
                 <button className="categoryEditButton">
                    <i className="fa-solid fa-pen"></i>
                </button>
                <button className="categoryCopyButton">
                    <i className="fa-regular fa-copy"></i>
                </button>
                <button className="categoryDeleteButton">
                    <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>

          <tr className="categoryTableBodyRow">
            <td className="categoryTableBodyCell">10</td>
            <td className="categoryTableBodyCell categoryNameText">
              Mức độ ưu tiên
            </td>
            <td className="categoryTableBodyCell">MUCUU_TIEN</td>
            <td className="categoryTableBodyCell">
              Danh mục hệ thống
            </td>
            <td className="categoryTableBodyCell">
              Danh sách mức độ ưu tiên
            </td>
            <td className="categoryTableBodyCell">
              <span className="categoryStatusActive">
                Hoạt động
              </span>
            </td>
            <td className="categoryTableBodyCell">10</td>
            <td className="categoryTableBodyCell">
              20/05/2024 10:30
            </td>
            <td className="categoryTableBodyCell">
              <div className="categoryActionGroup">
                 <button className="categoryEditButton">
                    <i className="fa-solid fa-pen"></i>
                </button>
                <button className="categoryCopyButton">
                    <i className="fa-regular fa-copy"></i>
                </button>
                <button className="categoryDeleteButton">
                    <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>

        </tbody>
      </table>

      {/* <!-- Footer --> */}
      <div className="categoryTableFooter">

        <div className="categoryFooterLeft">
          <span className="categoryFooterText">
            Hiển thị
          </span>

          <select className="categoryFooterSelect">
            <option>10</option>
          </select>

          <span className="categoryFooterText">
            dòng trên mỗi trang
          </span>
        </div>

        <div className="categoryFooterRight">

          <span className="categoryFooterPagingText">
            1 - 10 trong 28
          </span>

          <div className="categoryPagination">
            <button className="categoryPaginationButtonActive">
              1
            </button>

            <button className="categoryPaginationButton">
              2
            </button>

            <button className="categoryPaginationButton">
              3
            </button>

            <button className="categoryPaginationButton">
              »
            </button>
          </div>

        </div>

      </div>

    </div>

  </div>
</div>
            </div>
        );
    
}



export default CategoryList;